import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";

export function initHotelsProductsSlider() {
  const swiper = document.querySelector(".hotels-products__swiper");

  new Swiper(swiper, {
    modules: [Navigation, Pagination],
    slidesPerView: 1.2,
    spaceBetween: 15,
    speed: 800,
    navigation: {
      prevEl: ".hotels-products__btn-prev",
      nextEl: ".hotels-products__btn-next",
    },
    breakpoints: {
      768: { slidesPerView: 2.3, spaceBetween: 20 },
    },
  });
}
